import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import Test from './components/Test.vue'
// import Questions from './components/Questions.vue'
import ChannelLive from './components/ChannelLive.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // {
    //   path: '/test',
    //   name: 'test',
    //   component: Test
    // },
    // {
    //   path: '/question',
    //   name: 'question',
    //   component: Questions
    // },
    // {
    //   path: '/material',
    //   name: 'material',
    //   component: Materials
    // },
    // {
    //   path: '/testpage',
    //   name: 'testpage',
    //   component: () => import('./views/TestPage.vue')
    // },
    {
      path: '/live/:channelid',
      //name: 'Live',
      component: ChannelLive,
      props: true
    },
 
  ]
})
